
import { icons } from "../../../assets";
import { CustomMenu } from "../../../components";
import { TrainingMenuList } from "../../common/TrainingMenuList";

const menuItemElemen = [
    { imgHover: icons.dashboardBlue, img: icons.dasboardIcon, text: "Dashboard", viewId: 1, goTo: 'dashboard' },
    // { imgHover: icons.tableBlue, img: icons.table, text: "Tabla de registro", viewId: 3, goTo: "users" },
    { imgHover: icons.tableBlue, img: icons.table, text: "Usuarios", viewId: 2, goTo: "table" },
    { imgHover: icons.analiticsBlue, img: icons.analytics, text: "Analíticas", viewId: 4, goTo: "analytics" },
    { imgHover: icons.helpIcon, img: icons.helpWhite, text: "Ayuda", viewId: 5, goTo: "help" },
];

const TrainingMenu = () => {
    const Items = menuItemElemen.map((item) => {
        const { img, text, viewId, goTo, imgHover } = item;
        return <TrainingMenuList.Item key={viewId} imgHover={imgHover} img={img} text={text} viewId={viewId} goTo={goTo} />;
    });
    return (
        <CustomMenu>
            <TrainingMenuList>{Items}</TrainingMenuList>
        </CustomMenu>
    );
};

export default TrainingMenu;
